module.exports = "<span ng-bind=\"$ctrl.getName()\" ng-if=\"$ctrl.mode === 'view'\"></span>\n<select class=\"form-control input-sm\"\n        ng-class=\"$ctrl.inputClass\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-options=\"opt[0] as opt[0] for opt in $ctrl.productCodes\"\n        ng-if=\"$ctrl.mode === 'edit'\">\n</select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/product_code.picker.html
// module id = 682
// module chunks = 0